var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 101 100",
    width: 101,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.2842761 70.477628h7.2560242v-7.5409703h-7.2560242zm10.2345764-13.4708895h-13.2131286c-1.645244 0-2.9785523 1.3274933-2.9785523 2.9649596v13.4708895c0 1.6374663 1.3333083 2.9649596 2.9785523 2.9649596h13.2131286c1.6449732 0 2.9785523-1.3274933 2.9785523-2.9649596v-13.4708895c0-1.6374663-1.3335791-2.9649596-2.9785523-2.9649596z",
    fill: "#ef426f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.0900552 62.9367655h10.6374933v31.125876h5.9571046v-34.0908356c0-1.6374663-1.3335791-2.9649595-2.9785523-2.9649595h-16.5945979c-1.6449731 0-2.9785522 1.3274932-2.9785522 2.9649595v34.0908356h5.9571045z",
    fill: "#ef426f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.9514603 46.8927224c-1.6449732 0-2.9785523 1.3274932-2.9785523 2.9649595v44.2048518h-8.2882278-5.9571046-10.6374933-5.9571046-34.3765549v-44.2048518c0-1.6374663-1.3333083-2.9649595-2.9785523-2.9649595h-4.5783056l40.1649651-39.7469003 40.165236 39.7469003zm13.8992788.8622641-47.3863297-46.89245281c-1.1619062-1.14986523-3.0381233-1.14986523-4.2000295 0l-47.38578821 46.89245281c-.85538606.8466308-1.113437 2.1231806-.65338606 3.2331537.45978016 1.109973 1.54722252 1.8345013 2.75353619 1.8345013h8.82057638v42.8347709c0 2.3902965 2.0164799 4.3350404 4.4946354 4.3350404h40.1714638 13.8868231 14.0831367c2.4784263 0 4.4946354-1.9447439 4.4946354-4.3350404v-42.8347709h8.8208472c1.2063137 0 2.2934852-.7245283 2.7535362-1.8345013.45978-1.1099731.201729-2.3865229-.6536569-3.2331537z",
    fill: "#E3215F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.392586bdaeaacf0723c6613ea9f7c474.svg";
export { ForwardRef as ReactComponent };